<template>
  <update-business-member-field
    title="Nick Name"
    :value="member.nickName"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-text-field placeholder="Enter Nick name" v-model="nickName" required />
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nickName: "",
    };
  },
  methods: {
    handleIsEditing($event) {
      this.nickName = this.member.nickName;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        nickName: this.nickName,
      });
    },
  },
};
</script>
